<script setup lang="ts">
import { ref, onMounted, markRaw, defineAsyncComponent, computed, watch } from 'vue'
import Breadcrumb from '@/components/shared/dashboard/DashboardBreadcrumb_OLD.vue'
import type ILink from '@/components/shared/interface/ILink'
import { useBreadcrumbStore } from '@/stores/breadcrumb.store'
import { useRoute } from 'vue-router'
import { useOrganisationStore } from '@/stores/organisation.store'

const route = useRoute()
const organisationStore = useOrganisationStore()

enum PLANS_TAB_ENUM {
  MYPLANS = 'My Plans',
  MYORGANISATIONPLANS = 'My Plans',
  PAYMENTS = 'Payments'
}

const breadcrumbStore = useBreadcrumbStore()
const breadcrumbLinks = computed<ILink[]>(() => {
  if (organisationStore.isIndividualAccount) {
    return [
      {
        href: '/plans-payments',
        title: 'Plans & Payments'
      }
      // {
      //   href: '/plans-payments/payments',
      //   title: 'Payments'
      // }
    ]
  }

  return [
    {
      href: `/dashboard`,
      title: 'Home'
    },
    {
      href: `/plans-payments`,
      title: 'Plans & Payments'
    }
  ]
})

const isOrganisationAdmin = computed(() => {
  return organisationStore.isOrganisationAdmin
})

const tabs = [
  {
    name: isOrganisationAdmin.value ? PLANS_TAB_ENUM.MYORGANISATIONPLANS : PLANS_TAB_ENUM.MYPLANS,
    component: markRaw(
      defineAsyncComponent(() => import('@/components/plans-payments/MyPlans.vue'))
    )
  },
  {
    name: PLANS_TAB_ENUM.PAYMENTS,
    component: markRaw(
      defineAsyncComponent(() => import('@/components/plans-payments/PaymentsComp.vue'))
    )
  }
]

const tabsFiltered = computed(() => {
  return tabs.filter((tab) => {
    if (isOrganisationAdmin.value && tab.name === PLANS_TAB_ENUM.PAYMENTS) {
      return false
    }
    return true
  })
})

const currentTab = ref(
  route.query.tab
    ? tabs.filter((item) => {
        return item.name.toLowerCase() == route.query.tab
      })[0]
    : tabs[0]
)

watch(
  () => organisationStore.isIndividualAccount,
  () => {
    if (
      organisationStore.isIndividualAccount == true &&
      currentTab.value.name === PLANS_TAB_ENUM.MYORGANISATIONPLANS
    ) {
      currentTab.value.name = PLANS_TAB_ENUM.MYPLANS
    } else {
      currentTab.value.name = PLANS_TAB_ENUM.MYORGANISATIONPLANS
    }
  }
)

watch(
  () => breadcrumbLinks.value,

  () => {
    breadcrumbStore.setBreadcrumbLinks(breadcrumbLinks.value)
  }
)
onMounted(() => {
  breadcrumbStore.setBreadcrumbLinks(breadcrumbLinks.value)
})
</script>

<template>
  <div class="view-container">
    <Breadcrumb />

    <div class="mx-auto mb-12 mt-6 w-full max-w-xl">
      <nav class="flex w-full grow gap-10 transition" aria-label="Tabs" role="tablist">
        <button
          v-for="(tab, index) in tabsFiltered"
          :key="index"
          type="button"
          class="h-14 w-full rounded-t-lg border-b-[4px] text-center text-base font-semibold sm:text-xl"
          :class="[
            tab.name === currentTab.name ? 'border-new-secondary-600' : 'border-transparent',
            tabsFiltered.length === 1 ? 'mx-auto !w-auto' : null
          ]"
          role="tab"
          @click="currentTab = tab"
        >
          {{ tab.name }}
        </button>
      </nav>
    </div>

    <keep-alive>
      <component role="tabpanel" :is="currentTab.component" />
    </keep-alive>
  </div>
</template>
